import { useProjectEditDialog } from '@/hooks/useProjectEditDialog';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Keep existing edit links usable while the editor lives above the project view.
export default function ProjectEdit() {
  const { projectId } = useParams();
  const { search, hash } = useLocation();
  const navigate = useNavigate();
  const openProjectEdit = useProjectEditDialog();
  const openedProjectId = useRef<string | null>(null);

  useEffect(() => {
    if (!projectId || openedProjectId.current === projectId) return;
    openedProjectId.current = projectId;
    openProjectEdit(projectId);
    navigate({ pathname: `/projects/${projectId}`, search, hash }, { replace: true });
  }, [projectId, search, hash, navigate, openProjectEdit]);

  return null;
}
